<div class="card">
  <h5 class="page-title">Delivery Assignments</h5>

  <div *ngIf="featureDisabled" class="feature-disabled">
    TinyAll Delivery Network is not enabled on this environment
    (set <code>TINYALL_DELIVERY_NETWORK_ENABLED=true</code> on the backend).
  </div>

  <div class="toolbar">
    <label>
      State:
      <select [(ngModel)]="stateFilter" (change)="loadData()">
        <option *ngFor="let s of stateOptions" [value]="s">{{ s || 'All' }}</option>
      </select>
    </label>
    <label>
      Hub ID:
      <input type="text" [(ngModel)]="hubFilter" placeholder="filter by hub id" />
    </label>
    <label class="pending-fee-toggle">
      <input type="checkbox" [(ngModel)]="pendingFeeOnly" />
      Pending fee only
    </label>
    <button pButton type="button" icon="pi pi-search" label="Apply"
            class="p-button-sm" (click)="loadData()"></button>
    <button pButton type="button" icon="pi pi-refresh" label="Refresh"
            class="p-button-sm p-button-secondary" (click)="loadData()"></button>
  </div>

  <p-table
    [value]="displayedData"
    dataKey="id"
    [rows]="20"
    [paginator]="true"
    [rowsPerPageOptions]="[20,40,80]"
    [loading]="isLoading"
    styleClass="p-datatable-customers p-datatable-gridlines"
    [autoLayout]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Created</th>
        <th>Hub</th>
        <th>Source</th>
        <th>Order #</th>
        <th>Partner</th>
        <th>State</th>
        <th>Distance</th>
        <th>Order Amount</th>
        <th>Delivery Fee</th>
        <th>Network Fee</th>
        <th>Collect Cash</th>
        <th>Change For</th>
        <th>Accepted</th>
        <th>Picked up</th>
        <th>Delivered</th>
        <th>Issue</th>
        <th>Fee ledger</th>
        <th class="actions-col">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.createdOn | date: 'short' }}</td>
        <td>{{ item.hubId }}</td>
        <td>{{ item.orderSourceType }}</td>
        <td><span class="order-number" data-qa="admin-assignment-order-number">{{ formatOrderNumber(item.hubOrderNumber) }}</span></td>
        <td>
          <span class="courier-identity">
            <img *ngIf="item.deliveryPartnerPhotoUrl" class="courier-identity__photo" [src]="item.deliveryPartnerPhotoUrl" alt=""
                 loading="lazy" (error)="item.deliveryPartnerPhotoUrl = null" />
            <span *ngIf="!item.deliveryPartnerPhotoUrl" class="courier-identity__placeholder" aria-hidden="true"></span>
            <span>{{ item.deliveryPartnerName }}<br /><small>{{ item.deliveryPartnerPhone }}</small></span>
          </span>
        </td>
        <td><span class="state-tag" [ngClass]="stateSeverity(item.state)">{{ item.state }}</span></td>
        <td>{{ formatDistanceKm(item) }}</td>
        <td>{{ item.goodsSubtotal ?? '—' }}</td>
        <td>{{ item.deliveryFeeAmount }}</td>
        <td>{{ item.networkFeeAmount }}</td>
        <td><strong data-qa="admin-assignment-collect-cash">{{ item.collectFromCustomerAmount ?? item.finalCashTotal ?? '—' }}</strong></td>
        <td>{{ item.customerChangeForAmount ?? '—' }}</td>
        <td>{{ item.acceptedAt | date: 'short' }}</td>
        <td>{{ item.pickedUpAt | date: 'short' }}</td>
        <td>{{ item.deliveredAt | date: 'short' }}</td>
        <td data-qa="admin-assignment-issue">{{ latestIssueLabel(item) }}</td>
        <td>
          <span *ngIf="item.feeLedgerStatus" class="state-tag" [ngClass]="feeLedgerSeverity(item.feeLedgerStatus)">
            {{ item.feeLedgerStatus }}
          </span>
          <span *ngIf="!item.feeLedgerStatus">—</span>
        </td>
        <td class="actions-col">
          <button pButton type="button" label="Cancel" class="p-button-sm p-button-danger"
                  *ngIf="canCancel(item)"
                  (click)="confirmCancel(item)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="17">No delivery assignments found.</td></tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
